/* eslint no-unused-vars: 0 */
import 'core-js';
import 'regenerator-runtime/runtime';
import $ from 'jquery';

import { TriggerAnimation } from './scroll-actions';

import initCookiePopup from './cookie-popup';
import initPopup from './popup';
import initScrollTo from './scroll-to';
import mobileMenu from './menu';
import share from './share';
import mobileMenuChildren from './menu-children';
import toggle from './toggle';
import toggleCountries from './toggle-countries'
import Slider from './slider';
import EmbedMessage from './embed-message';
import DisclaimerForm from './disclaimer-form';
import FundHistory from './fund-history';
import Pagination from './pagination';

$(document).ready(() => {

    const $visible = $('.js-visible');
    if ($visible.length) {
        $visible.map((i, v) => TriggerAnimation(i, v));
    }

    const $cookiePopup = $('.js-cookie-popup');
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $popup = $('.js-popup');
    if ($popup.length) {
        $popup.map((i, v) => initPopup(v));
    }

    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsMobileChildren = $('.js-toggle-children');
    if ($jsMobileChildren.length) {
        $jsMobileChildren.map((i, v) => mobileMenuChildren(v));
    }

    const $jsToggleCountries = $('.js-toggle-countries');
    if ($jsToggleCountries.length) {
        $jsToggleCountries.map((i, v) => toggleCountries(v));
    }

    // For toggling specific elements by id or class
    const $jsToggle = $('.js-toggle');
    if ($jsToggle.length) {
        $jsToggle.map((i, v) => toggle(v));
    }

    const $jsShare = $('.js-share');
    if ($jsShare.length) {
        $jsShare.map((i, v) => share(v));
    }

    const $slider = $('.js-slider');
    if ($slider.length) {
        $slider.map((i, v) => Slider(v));
    }

    const $embedMessage = $('.js-embed-message');
    if ($embedMessage.length) {
        $embedMessage.map((i, v) => EmbedMessage(v));
    }

    const $disclaimerForm = $('.js-disclaimer-form');
    if ($disclaimerForm.length) {
        $disclaimerForm.map((i, v) => DisclaimerForm(v));
    }

    const $fundHistory = $('.js-fund-history');
    if ($fundHistory.length) {
        $fundHistory.map((i, v) => FundHistory(v));
    }

    const $pagination = $('.js-pagination');
    if ($pagination.length) {
        $pagination.map((i, v) => Pagination(v));
    }
});
